import { render, staticRenderFns } from "./MyList.vue?vue&type=template&id=44979478&scoped=true"
import script from "./MyList.vue?vue&type=script&lang=js"
export * from "./MyList.vue?vue&type=script&lang=js"
import style0 from "./MyList.vue?vue&type=style&index=0&id=44979478&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44979478",
  null
  
)

export default component.exports